import injectDependencies from './inject-dependencies';
import ejectDependencies from './eject-dependencies';

export default {
  injectDependencies,
  ejectDependencies,
};
